import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  const handleDarkPatternClick = () => {
    navigate('/version2');
  };

  const handleDigitalViolationClick = () => {
    navigate('/digital-version2');
  };

  const handleVideoAnalysisClick = () => {
    window.open('https://video-violation-analysis-413055756357.europe-west1.run.app/', '_blank');
  };

  const handleExternalLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const quickLinkCards = [
    {
      title: 'Tik Tok scraper',
      description: 'Scrape Tik Tok videos for pattern insights and key ecosystem trends.',
      buttonText: 'Open Tik Tok scraper',
      url: 'https://tiktok-scrape-analyze-413055756357.europe-west1.run.app/'
    },
    {
      title: 'Chrome Extension',
      description: 'Install Deceptive Design Detection from the Chrome Web Store.',
      buttonText: 'Open Extension',
      url: 'https://chromewebstore.google.com/detail/deceptive-design-detectio/bmhfcnabdlfcgcnmfjabpchedfncpkmn?authuser=0&hl=en'
    },
    {
      title: 'Chat App',
      description: 'Ask questions and explore fair pattern guidance quickly.',
      buttonText: 'Open Chat App',
      url: 'https://chat.fairpatterns.com'
    },
    {
      title: 'Review Tool',
      description: 'Run structured reviews for UI and compliance checks.',
      buttonText: 'Open Review Tool',
      url: 'https://review.fairpatterns.com'
    },
    {
      title: 'Report App',
      description: 'Generate and share detailed assessment reports.',
      buttonText: 'Open Report App',
      url: 'https://report.fairpatterns.com'
    },
    {
      title: 'Observatory Dashboard',
      description: 'Monitor pattern insights and key ecosystem trends.',
      buttonText: 'Open Dashboard',
      url: 'https://observatory.fairpatterns.com'
    },
    {
      title: 'Cookie Consent Analyzer',
      description: 'Analyze cookie consent implementations for compliance and privacy risks.',
      buttonText: 'Open Cookie Analyzer',
      url: 'https://cookie-analysis-fairpatterns.vercel.app/'
    }
  ];

  return (
    <div className="home-container">
      <main className="home-content">
        <h1 className="main-title">
          Scan, analyze, and improve<br />your digital designs
        </h1>
        
        <p className="main-description">
          AI-powered tools to detect manipulative design, compliance risks,<br />and improve user trust.
        </p>

        {/* <h2 className="section-title">
          Choose your analysis type to get started
        </h2> */}

          {/* Dark Patterns Card */}
        {/* <div className="cards-container">
          <div className="analysis-card" onClick={handleDarkPatternClick}>
            <div className="card-icon">
              <img src="/assets/dark_pattern_logo.png" alt="Dark Patterns" />
            </div>
            <h3>Dark Patterns</h3>
            <p>Detect deceptive design patterns that manipulate user behavior.</p>
            <button className="card-button">Start Dark Pattern Analysis</button>
          </div> */}

          {/* Digital Violations Card */}
          {/* <div className="analysis-card" onClick={handleDigitalViolationClick}>
            <div className="card-icon">
              <img src="/assets/digital_logo.png" alt="Digital Violations" />
            </div>
            <h3>Digital Violations</h3>
            <p>Find and assess digital compliance and regulatory breaches.</p>
            <button className="card-button">Start Compliance Check</button>
          </div> */}

          {/* Video Analysis Card */}
          {/* <div className="analysis-card" onClick={handleVideoAnalysisClick}>
            <div className="card-icon">
              <img src="/assets/video_logo.png" alt="Video Analysis" />
            </div>
            <h3>Video Analysis</h3>
            <p>Analyze videos for dark patterns and compliance issues.</p>
            <button className="card-button">Analyze a Video</button>
          </div>
        </div> */}

        <h2 className="section-title">Quick links</h2>
        <div className="quick-links-container">
          {quickLinkCards.map((card) => (
            <div
              key={card.title}
              className="quick-link-card"
              onClick={() => handleExternalLinkClick(card.url)}
            >
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <button className="quick-link-button">{card.buttonText}</button>
            </div>
          ))}
        </div>

        <p className="bottom-text">
          Start detecting risks and improving your designs today.
        </p>
      </main>
    </div>
  );
};

export default HomePage; 